// Custom Email Popup Logic
document.addEventListener('DOMContentLoaded', () => {
  const PAGE_VIEW_TRIGGER_COUNT = 3;
  const ENGAGEMENT_TIME_SHORT_MS = 7000; // 15 seconds
  const ENGAGEMENT_TIME_LONG_MS = 15000;  // 30 seconds
  const ENGAGEMENT_SCROLL_DEPTH = 0.30;   // 50% scroll depth

  const SESSION_STORAGE_PAGE_VIEW_KEY = 'plantPlugPageViews';
  const SESSION_STORAGE_POPUP_SHOWN_KEY = 'plantPlugEmailPopupShown';
  // const EMAIL_REGEX = /^\S+@\S+\.\S+$/; // No longer needed

  const popupOverlay = document.querySelector('.email-popup-overlay:not(.js-initialized)');

  if (!popupOverlay) { return; }
  popupOverlay.classList.add('js-initialized');

  const sectionId = popupOverlay.dataset.sectionId;
  const closeButton = popupOverlay.querySelector('.email-popup__close-btn');
  // References to form elements and messages removed as they are handled by Liquid now
  // const form = popupOverlay.querySelector(`#email-popup-form-${sectionId}`);
  // const successMessageEl = popupOverlay.querySelector(`#popup-success-message-${sectionId}`);
  // const errorMessageEl = popupOverlay.querySelector(`#popup-error-message-${sectionId}`);
  // const submitButton = form ? form.querySelector('button[type="submit"]') : null;
  // const emailInput = form ? form.querySelector('input[type="email"]') : null;

  let desktopExitListenerActive = false;
  let engagementScrollListenerActive = false;
  let engagementTimeoutShortId = null;
  let engagementTimeoutLongId = null;

  // --- Helper Functions ---
  const getCurrentPageViewCount = () => {
      return parseInt(sessionStorage.getItem(SESSION_STORAGE_PAGE_VIEW_KEY) || '0', 10);
  };

  const incrementPageView = () => {
      let count = getCurrentPageViewCount();
      count++;
      sessionStorage.setItem(SESSION_STORAGE_PAGE_VIEW_KEY, count.toString());
      console.log(`Page views: ${count}`); // Keep for debugging triggers
      return count;
  };

  const setPopupShownFlag = () => {
      sessionStorage.setItem(SESSION_STORAGE_POPUP_SHOWN_KEY, 'true');
  };

  const hasPopupBeenShown = () => {
      return sessionStorage.getItem(SESSION_STORAGE_POPUP_SHOWN_KEY) === 'true';
  };

  const removeExitIntentListeners = () => {
      if (desktopExitListenerActive) {
          document.removeEventListener('mouseout', desktopExitHandler);
          desktopExitListenerActive = false;
      }
      if (engagementScrollListenerActive) {
          document.removeEventListener('scroll', engagementScrollHandler);
          engagementScrollListenerActive = false;
      }
      if (engagementTimeoutShortId) {
          clearTimeout(engagementTimeoutShortId);
          engagementTimeoutShortId = null;
      }
      if (engagementTimeoutLongId) {
          clearTimeout(engagementTimeoutLongId);
          engagementTimeoutLongId = null;
      }
  };

  const showPopup = () => {
      // Cancel all other triggers first
      removeExitIntentListeners();

      if (popupOverlay && !popupOverlay.classList.contains('is-visible')) {
          console.log('Showing popup...');
          popupOverlay.classList.add('is-visible');
          // Flag is set on manual close or successful submit
      }
  };

  const hidePopup = () => {
      if (popupOverlay && popupOverlay.classList.contains('is-visible')) {
          popupOverlay.classList.remove('is-visible');
      }
  };

  // Message and button helper functions removed (hideMessages, showSuccessMessage, showErrorMessage, enable/disableSubmitButton)

  // --- Trigger Logic Handlers ---
  const desktopExitHandler = (event) => {
      // Add small buffer to prevent accidental triggers scrolling to top
      if (!hasPopupBeenShown() && event.clientY <= 10) { 
          console.log('Desktop exit intent detected.');
          showPopup();
      }
  };

  const engagementScrollHandler = () => {
      const scrollDepth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      // console.log('Scroll depth check:', scrollDepth);
      if (!hasPopupBeenShown() && scrollDepth >= ENGAGEMENT_SCROLL_DEPTH) {
          console.log('Engagement scroll depth reached.');
          showPopup(); 
          // Listener removal happens in removeExitIntentListeners called by showPopup
      }
  };

  // --- Trigger Setup Functions ---
  const startEngagementTriggers = () => {
      console.log('Starting engagement triggers (Page >= 3).');
      removeExitIntentListeners(); // Clear any previous just in case

      engagementTimeoutLongId = setTimeout(() => {
          if (!hasPopupBeenShown()) {
              console.log(`Engagement time reached (${ENGAGEMENT_TIME_LONG_MS / 1000}s).`);
              showPopup();
          }
      }, ENGAGEMENT_TIME_LONG_MS);

      engagementTimeoutShortId = setTimeout(() => {
          if (!hasPopupBeenShown()) {
              const currentScrollDepth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
              if (currentScrollDepth >= ENGAGEMENT_SCROLL_DEPTH) {
                  console.log(`Engagement scroll depth already met after ${ENGAGEMENT_TIME_SHORT_MS / 1000}s.`);
                  showPopup();
              } else {
                  console.log(`Adding engagement scroll listener after ${ENGAGEMENT_TIME_SHORT_MS / 1000}s.`);
                  document.addEventListener('scroll', engagementScrollHandler, { passive: true });
                  engagementScrollListenerActive = true;
              }
          }
      }, ENGAGEMENT_TIME_SHORT_MS);
  };

  const addExitIntentListeners = () => {
      // Only adding desktop listener as fallback
      console.log('Adding desktop exit intent listener (Page < 3).');
      removeExitIntentListeners(); // Clear previous just in case
      document.addEventListener('mouseout', desktopExitHandler);
      desktopExitListenerActive = true;
  };

  // --- Form Handling Removed --- 
  // const handleFormSubmit = (event) => { ... }; 

  // --- Initialization ---
  const checkTriggers = () => {
    if (hasPopupBeenShown()) {
      console.log('Popup already shown this session.');
      return;
    }

    const currentPageViews = incrementPageView();

    if (currentPageViews >= PAGE_VIEW_TRIGGER_COUNT) {
      startEngagementTriggers();
    } else {
      addExitIntentListeners();
    }
  };

  const setupEventListeners = () => {
    if (closeButton) {
      closeButton.addEventListener('click', () => {
          hidePopup();
          setPopupShownFlag(); // Set flag if closed manually
      });
    }
    popupOverlay.addEventListener('click', (event) => {
      if (event.target === popupOverlay) {
        hidePopup();
        setPopupShownFlag(); // Set flag if closed manually
      }
    });

    // Removed form submit and email input listeners
    // if (form) { form.addEventListener('submit', handleFormSubmit); }
    // if (emailInput) { emailInput.addEventListener('input', hideMessages); }
  };

  // --- Run ---
  checkTriggers();
  setupEventListeners();

}); // End DOMContentLoaded 